import CancelIcon from '@mui/icons-material/Cancel';
import IconButton from '@mui/material/IconButton';
import { GradientIcon } from '../gradients/GradientIcon';

type AuthenticationCloseButtonProps = {
  closeModal: () => void;
  forAuthNavbar?: boolean;
};
export function AuthenticationCloseButton({
  closeModal: onClose,
  forAuthNavbar,
}: AuthenticationCloseButtonProps) {
  return (
    <IconButton onClick={onClose} edge={!!forAuthNavbar ? 'end' : false}>
      <GradientIcon
        IconComponent={CancelIcon}
        gradientColor={'primary.horizontal'}
      />
    </IconButton>
  );
}
